export const secondsUntil = (target: number | null, now: number): number =>
  target === null ? 0 : Math.max(0, Math.ceil((target - now) / 1000));

export const formatMmSs = (seconds: number): string => {
  const safe = Math.max(0, Math.floor(seconds));
  const mins = Math.floor(safe / 60);
  const secs = safe % 60;
  return `${mins}:${String(secs).padStart(2, '0')}`;
};
